export class CompanyAttachmentType {
	public id: number;
	public companyId: string;
	public attachmentTypeId: string;
	public displayName: string;
	public validMonths: number;

	constructor(companyAttachmentType?: CompanyAttachmentType) {
		Object.assign(this, companyAttachmentType);
	}
}
